import { useEffect, useState, type ReactNode } from "react";
import { createPortal } from "react-dom";
import isBrowser from "../utils/isBrowser";

type PortalProps = {
  children: ReactNode;
  containerId?: string;
};

export default function Portal({ children, containerId }: PortalProps) {
  // In some cases the chosen container element is not being rendered before the Portal component is rendered,
  // which causes getElementById to return null. Using the useEffect ensures to wait until the whole dom is ready.
  // ref: https://stackoverflow.com/a/66447347
  const [domReady, setDomReady] = useState<boolean>(false);

  useEffect(() => {
    setDomReady(true);
  }, []);

  if (!isBrowser()) return <>{children}</>;

  return domReady
    ? createPortal(
        children,
        containerId
          ? document.getElementById(containerId) ?? document.body
          : document.body
      )
    : null;
}
